import classnames from 'classnames';

import Image from 'molecules/Image';
import RichText from 'molecules/RichText';

import styles from 'components/Switchbacks/TextWithBackgroundImage/horizontal-card.module.scss';

import type { ImageProps } from 'molecules/Image';
import type { FC } from 'react';

interface HorizontalCardProps {
  heading: string;
  content?: string;
  image?: ImageProps;
  classes?: Record<string, string>;
}

const HorizontalCard: FC<HorizontalCardProps> = ({ heading, content, image, classes = {} }) => (
  <div className={styles.wrapper}>
    {image?.url && (
      <div className={styles.imageContainer}>
        <Image
          width={image?.width || 0}
          height={image?.height || 0}
          url={image?.url}
          alt={image?.alt || 'Horizontal Card Image'}
        />
      </div>
    )}
    <div className={styles.contentContainer}>
      {heading && (
        <p
          className={classnames(styles.contentHeading, {
            [classes.heading]: classes.heading,
          })}
        >
          {heading}
        </p>
      )}
      {content && (
        <RichText
          className={classnames(styles.content, {
            [classes.content]: classes.content,
          })}
          content={content}
        />
      )}
    </div>
  </div>
);

export default HorizontalCard;
